export default "__VITE_ASSET__a56d9377__"